module.exports = __webpack_public_path__ + "static/assets/c4307d49ed214b65cf134a07963bf0e7.svg";